'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import type { JSX } from 'react';
import { PipelineStepBadge } from '../pipeline-step-badge';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';

interface IPublishStepProps {
  item: ICollectionPipelineStatusV3;
}

export function PublishStep({ item }: IPublishStepProps): JSX.Element {
  const { published } = item.steps;
  return (
    <PipelineStepCell
      badge={<PipelineStepBadge step={published} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Publish"
          description={`Mark translated challenges as published so they appear in the user feed. ${published.done}/${published.total} published. Publishing is per-challenge from the challenges page.`}
          dataHref={`/sys/challenges?collectionId=${item.collectionId}`}
          dataLabel="Open challenges"
        />
      )}
    />
  );
}
